let BASE_URL = "https://api.lipigo.com/api/v1";

if (process.env.REACT_APP_ENV === "prod") {
  BASE_URL = "https://api.lipifitcrm.com/api/v1";
}

export { BASE_URL };
